const calculateImputedPaO2 = (params) => {
  const { spo2 } = params;
  if (spo2 === 100 || spo2 === '100') {
    return 0;
  } else {
    const s = spo2 / 100;
    const baseFraction = 11700 / (1 / s - 1);
    const innerRight = Math.sqrt(Math.pow(50, 3) + Math.pow(baseFraction, 2));
    const firstHalf = Math.cbrt(baseFraction + innerRight);
    const secondHalf = Math.cbrt(baseFraction - innerRight);
    return firstHalf + secondHalf;
  }
};

const calculatePfratio = (params) => {
  const { fio2 } = params;
  const imputedPao2 = calculateImputedPaO2(params);
  return imputedPao2 / (fio2 / 100);
};

const calculateSfratio = (params) => {
  const { spo2, fio2 } = params;
  return spo2 / (fio2 / 100);
};

export { calculateImputedPaO2, calculatePfratio, calculateSfratio };
